<template>
  <a @click="openContentModal" v-if="isImage">See file</a>
  <a :href="link" v-else target="_blank">See file</a>
</template>

<script>
const imageExt = ['png', 'jpeg', 'jpg'];

export default {

  props: {
    link: String,
  },
  computed: {
    isImage() {
      const ext = this.link.split('.').pop();
      return imageExt.indexOf(ext) !== -1;
    },
  },
  methods: {
    openContentModal() {
      this.$modal.open(
        `<p class="image safe-link-image-container" style="background-image: url('${this.link}');"/>`,
      );
    },
  },
};
</script>

<style lang="scss">
.safe-link-image-container {
  height: 70vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-color: transparent;
}
</style>
